export const differenceInMs = (timeStamp: Date) => {
  const now = Date.now();
  const ts = new Date(timeStamp);

  const ms = ts.getTime();

  return now - ms;
};
